import { Box, Card, Stack, Typography, ValidationErrors } from "@compass/core";
import { PartnerIndirectCost as PartnerIndirectCostModel, PartnerIndirectCostViewResource } from "generated/openApi";
import { PartnerIndirectCostPageBody } from "pages/match-utility/partner-indirect-costs/PartnerIndirectCostPage/PartnerIndirectCostPageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const PartnerIndirectCost = (props: {
  indirectCost: PartnerIndirectCostModel;
  setIndirectCost: (value: PartnerIndirectCostModel) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<PartnerIndirectCostViewResource>({});

  useEffect(() => {
    fetchViewResource();
  }, []);

  const fetchViewResource = () => {
    ApiService.partnerIndirectCosts.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Card
      header={
        <Stack>
          <Box>Indirect Cost</Box>
          <Typography variant="caption">
            An Indirect Cost is required when creating a partner. You may add more indirectCosts after succesfully
            creating this partner.
          </Typography>
        </Stack>
      }
    >
      <PartnerIndirectCostPageBody
        crudMode="edit"
        indirectCost={props.indirectCost}
        setIndirectCost={(value) => props.setIndirectCost(value)}
        viewResource={viewResource}
        validationErrors={props.validationErrors}
      />
    </Card>
  );
};
